/* MBG Advantages Steps
   Mobile: pagination dots for the swipeable cards.
   Tablet and desktop: the same track works as a slider with arrows,
   but only while the cards overflow the container.
   Loaded only when the section renders more than one card. */
(function () {
    'use strict';

    var ROOT_SELECTOR = '[data-mbg-as]';
    var ACTIVE_CLASS = 'mbg-advantages-steps__carousel--active';
    var TOLERANCE = 2;

    function init(root) {
        if (root.dataset.mbgAsReady === 'true') return;

        var scroller = root.querySelector('[data-mbg-as-scroller]');
        if (!scroller) return;

        var cards = Array.prototype.slice.call(scroller.children);
        if (cards.length < 2) return;

        root.dataset.mbgAsReady = 'true';

        var dots = Array.prototype.slice.call(root.querySelectorAll('[data-mbg-as-dot]'));
        var prev = root.querySelector('[data-mbg-as-prev]');
        var next = root.querySelector('[data-mbg-as-next]');

        function limit() {
            return scroller.scrollWidth - scroller.clientWidth;
        }

        function scrollTo(left) {
            var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            scroller.scrollTo({
                left: Math.max(0, Math.min(limit(), left)),
                behavior: reduced ? 'auto' : 'smooth'
            });
        }

        function activate(index) {
            for (var i = 0; i < dots.length; i++) {
                dots[i].setAttribute('aria-current', i === index ? 'true' : 'false');
            }
        }

        /* offsetLeft of both cards is measured from the same offset parent,
           so the difference is the exact scroll distance. */
        function onDotClick(event) {
            var index = dots.indexOf(event.currentTarget);

            scrollTo(cards[index].offsetLeft - cards[0].offsetLeft);
        }

        /* One card + one gap per click; wraps around at both ends. */
        function step() {
            var gap = parseFloat(window.getComputedStyle(scroller).columnGap);

            return cards[0].getBoundingClientRect().width + (isNaN(gap) ? 0 : gap);
        }

        function slide(direction) {
            var max = limit();

            if (max <= TOLERANCE) return;

            if (direction > 0 && scroller.scrollLeft >= max - TOLERANCE) {
                scrollTo(0);
            } else if (direction < 0 && scroller.scrollLeft <= TOLERANCE) {
                scrollTo(max);
            } else {
                scrollTo(scroller.scrollLeft + direction * step());
            }
        }

        function sync() {
            var active = limit() > TOLERANCE;

            if (active) {
                root.classList.add(ACTIVE_CLASS);
            } else {
                root.classList.remove(ACTIVE_CLASS);
                scroller.scrollLeft = 0;
            }

            if (!prev || !next) return;

            prev.setAttribute('aria-hidden', active ? 'false' : 'true');
            next.setAttribute('aria-hidden', active ? 'false' : 'true');
            prev.tabIndex = active ? 0 : -1;
            next.tabIndex = active ? 0 : -1;
        }

        if (dots.length === cards.length) {
            for (var i = 0; i < dots.length; i++) {
                dots[i].addEventListener('click', onDotClick);
            }

            /* IntersectionObserver instead of a scroll listener — no work between snap points. */
            if ('IntersectionObserver' in window) {
                var observer = new IntersectionObserver(
                    function (entries) {
                        for (var e = 0; e < entries.length; e++) {
                            if (entries[e].isIntersecting) {
                                activate(cards.indexOf(entries[e].target));
                            }
                        }
                    },
                    { root: scroller, threshold: 0.6 }
                );

                for (var c = 0; c < cards.length; c++) {
                    observer.observe(cards[c]);
                }
            }
        }

        if (prev && next) {
            prev.addEventListener('click', function () {
                slide(-1);
            });

            next.addEventListener('click', function () {
                slide(1);
            });
        }

        sync();

        if (window.ResizeObserver) {
            new ResizeObserver(sync).observe(scroller);
        } else {
            window.addEventListener('resize', sync);
        }
    }

    function initAll(scope) {
        var roots = (scope || document).querySelectorAll(ROOT_SELECTOR);

        for (var i = 0; i < roots.length; i++) {
            init(roots[i]);
        }
    }

    initAll();

    document.addEventListener('shopify:section:load', function (event) {
        initAll(event.target);
    });
})();
